<template>
	<v-card 
		class="text-center mx-auto"
		max-width="400"
		width="100%"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>

		<v-card-text v-if="errors.length > 0">
			<div><strong>Виявлено критичні помилки</strong></div>
			<v-icon color="error" icon="mdi-alert-circle" size="100"></v-icon>

			<v-banner v-for="(item, i) in errors" :key="i"
				color="error"
				lines="two"
				stacked
				density="compact"
			>
				<v-banner-text class="text-left">
					 <div><strong>{{ item.name }}</strong></div>
					 <div v-for="(error, i) in item.errors" :key="i">
						{{ error }}
					 </div>
				</v-banner-text>
				<template v-slot:actions>
					<v-btn @click="$emit('step', item.code)">Виправити</v-btn>
				</template>
			</v-banner>

		</v-card-text>
		<v-card-text v-else>
			<div><strong>Перевірка успішна</strong></div>
			<v-icon color="success" icon="mdi-check-circle-outline" size="100"></v-icon>
		</v-card-text>

		
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	
	props: {
		//window:				{ type: Object, default: () => {} },
		windows:			{ type: Array, default: () => [] },
	},

	computed: {
		errors() {
			//console.log('errors', 'errors', this.windows.filter((element) => element.errors.length > 0))
			return this.windows.filter((element) => element.errors.length > 0)
		},
	},

	methods: {
		
	},
}
</script>
